import { render, staticRenderFns } from "./storeGoodsLayout.vue?vue&type=template&id=1d98830c&scoped=true&"
import script from "./storeGoodsLayout.vue?vue&type=script&lang=js&"
export * from "./storeGoodsLayout.vue?vue&type=script&lang=js&"
import style0 from "./storeGoodsLayout.vue?vue&type=style&index=0&id=1d98830c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98830c",
  null
  
)

export default component.exports